import {Modal} from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from '../../../../utils/utils'
import intl from "../../../../i18n/intl";
const UpgradePlanModal = ({num,upgradeOpen,setUpgradeOpen,pointsData,handlePointsRedeem}) => {
    const router  = useHistory()

  return (
    <div className="upgrade_new_feature">
      <Modal
        open={upgradeOpen}
        onClose={() => setUpgradeOpen()}
        title={intl.get('Reach the import product limit')}
        primaryAction={{
          content: intl.get("Upgrade Plan"),
          onAction: () => {
            setUpgradeOpen()
            utils.routeListen('/admin/subscribe')
            utils.routeJump1(router,'/admin/subscribe')
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Redeem Points"),
            onAction: () => {
              handlePointsRedeem()
              setUpgradeOpen()
            },
          },
        ]}
      >
        <Modal.Section>
        <p style={{margin:"10px",fontSize:'14px'}}>{`You've reached the daily limit of importing ${num} AliExpress products. Upgrade your plan for more imports, or use 150 points to import 1 more product (Remaining points: ${pointsData.available_points}).`}</p>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default UpgradePlanModal;
